var map = {
	"./careers.svg": 431,
	"./certificate.svg": 883,
	"./education.svg": 596,
	"./interests.svg": 71,
	"./profiles.svg": 648,
	"./programming-skills.svg": 484,
	"./projects.svg": 964,
	"./services.svg": 206,
	"./solution.svg": 807,
	"./work-history.svg": 862
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 856;